import { ModalWrapper, TimeSwitch } from "src/utils/fw"
import { isMember, modalColor } from "../utils"
import { AgendaSidebar } from "../components/AgendaSidebar"
import auditoriumTwo from "../data/auditoriumTwo"
import { SessionsComponent } from "../data/auditoriumOne"


const memberLinks = [
	{
		height: "15.7%",
		href: "/atrium",
		isExternal: false,
		label: "Atrium",
		left: "38.3%",
		top: "80.9%",
		width: "7.6%",
	},
	{
		height: "15.7%",
		href: "https://isfcongress.tkeventsregistration.com/2024-feedbackaud2/",
		label: "Feedback",
		left: "46.1%",
		target: "_blank",
		top: "80.9%",
		width: "7.6%",
		onClick: () => {
			const session = getCurrentSession(auditoriumTwo())
			if (!session) return;

			//check if session has ID
			const achID = achievements.find(it => it.name === `Provide Feedback - ${session.title}`)?.id
			
			if (!achID) return;
			assignAchievement({
                achievementId: achID,
                eventId: "161759",
                userId: userID
            })
		}
	},
	{
		height: "15.7%",
		modal: <ModalWrapper wrapperStyle={{height: "fit-content", maxHeight: "100%", backgroundColor: modalColor}}>
			<iframe src="https://app.sli.do/event/5KaWzBctKJsDXeEDqUFPN4" height="100%" width="100%" frameBorder="0" style="height: 95.8vh; width: 400px" title="Slido"></iframe>
		</ModalWrapper>,
		modalOverrides: {
			backdropStyle: {
				justifyContent: "flex-start",
				"background": "none"
			},
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		},
		label: "Slido",
		left: "54.1%",
		top: "80.9%",
		width: "7.6%",
	},
]

export default {
	background: "https://assets.swoogo.com/uploads/full/4570968-671964036249a.png",
	 extras: (
		<>
			<SessionsComponent sessions={auditoriumTwo()} name="AuditoriumTwoSC" />
			<div style={{
				height: "70.4%",
				left: "19%",
				top: "5.1%",
				width: "62.05%",
				position: "absolute"
			}}>
				<iframe
					src="https://vimeo.com/event/4672883/embed/fbbb8afbab?autoplay=1&pip=0"
					// src="https://video.ibm.com/embed/26199406?autoplay=true&showtitle=false"
					allowfullscreen
					disablePictureInPicture
					allow="autoplay"
					style={{
						height: "100%",
						width: "100%",
						border: 0
					}}
				/>
			</div>
			<div style={{
				height: "85.1%",
				left: "82.3%",
				top: "2.1%",
				width: "16.7%",
				position: "absolute",
				textAlign: "right"
			}}>
				<AgendaSidebar agenda={auditoriumTwo()} />
			</div>
	</>
	 ),
	links: [
		...(isMember ? memberLinks : []),
	],
	name: "auditorium-two",
}
